import { Pencil, Trash2 } from "lucide-react";

export default function DocumentRow({ document, onEdit, onDelete }) {
  return (
    <tr>
      <td>
        <div className="userCell">
          <div>
            <div className="userName">{document.name}</div>
          </div>
        </div>
      </td>

      <td>
        {document.isRequired ? (
          <span className="badge green">Requis</span>
        ) : (
          <span className="badge gray">Non requis</span>
        )}
      </td>

      <td>
        {document.isMultiple ? (
          <span className="badge blue">Plusieurs fichiers</span>
        ) : (
          <span className="badge gray">1 seul fichier</span>
        )}
      </td>

      <td className="center">
        <div className="actions">
          <button
            type="button"
            className="iconBtn edit"
            title="Modifier"
            onClick={() => onEdit(document)}
          >
            <Pencil size={18} />
          </button>

          <button
            className="iconBtn danger"
            title="Supprimer"
            onClick={() => onDelete(document)}
          >
            <Trash2 size={16} />
          </button>
        </div>
      </td>
    </tr>
  );
}
